import { IconType } from "react-icons";
import { useAppSelector } from "../../hooks";
import IMeasurement from "../../interfaces/measurement.interface";
import { FaBan, FaExclamationTriangle } from "react-icons/fa";
import { ReactElement } from "react";
import IShipsConfig, { IShipsInstrument, IShipsSensor } from "../../interfaces/config.interface";

export interface validity {
    color: string;
    icon: ReactElement|null;
}

export function getConfigByPath(path:string, config:IShipsConfig): IShipsSensor|null{
    const [instrumentName, sensorId] = path.split(".");

    for (const instrument of config.instruments) {
        if (instrument.name === instrumentName) {
            for (const sensor of instrument.sensors) {
                if (sensor.id === sensorId) {
                    return sensor;
                }
            }
        }
    }

    return null;
}

export function checkTimestampStatus(timestamp: Date | undefined, frequency: number | undefined): validity {
    if(frequency){
        const currentTime = Date.now();
        const twiceFrequency = 2 * frequency;
        const fourTimesFrequency = 4 * frequency;
        let color = ""
        
        if (timestamp) {
            const date = new Date(timestamp);
            const timeDifference = currentTime - date.getTime();

            if (timeDifference >= fourTimesFrequency) {
                const v:validity = {color:'red-frequency', icon:<FaBan/>}; 
                return v
            } else if (timeDifference >= twiceFrequency) {
                const v:validity = {color:'goldenrod', icon:<FaExclamationTriangle/>}; 
                return v
            } else {
                const v:validity = {color:'green-frequency', icon:null}; 
                return v
            }
        }
    }
    const v:validity = {color:'red-frequency', icon:<FaBan/>}; 
    return v
}

export function getByPath(path: string, measurementsList: IMeasurement[]) {

    // console.log('path: ' + path);
    // console.log('measurements: ' + measurementsList);
    for (var m of measurementsList) {
        if (path == m.path) {
            // console.log('found: ' + m.path);
            return m;
        }
    }
};